import { render } from "./CTAWhatToDoSection.vue?vue&type=template&id=71337c0c&scoped=true"
import script from "./CTAWhatToDoSection.vue?vue&type=script&lang=js"
export * from "./CTAWhatToDoSection.vue?vue&type=script&lang=js"

import "./CTAWhatToDoSection.vue?vue&type=style&index=0&id=71337c0c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71337c0c"]])

export default __exports__